import { TooltipContainer } from '@terminal/components/tooltip-container/TooltipContainer';
import clsx from 'clsx';
import { ReactNode } from 'react';

import { formatProportionChange } from '../utils';
import styles from './MarketReactionLegendRow.module.scss';

export interface MarketReactionLegendRowProps {
  icon: ReactNode;
  color: string;
  name?: string;
  ticker?: string;
  proportionChange?: number;
}

export const MarketReactionLegendRow = ({
  icon,
  color,
  name,
  ticker,
  proportionChange,
}: MarketReactionLegendRowProps) => (
  <div className={styles.legendRow}>
    <div className={styles.legendItem}>
      <div className={styles.iconWrapper}>
        <div className={styles.legendItemVector} style={{ borderColor: color }} />
        {icon}
      </div>
      <div className={styles.entityDetails}>
        <TooltipContainer label={name ?? ''}>
          <span className={styles.entityName}>{name}</span>
        </TooltipContainer>
        {ticker && <span className={styles.entityTag}>{ticker}</span>}
      </div>
    </div>
    {proportionChange !== undefined && (
      <span
        className={clsx(styles.proportionChange, {
          [styles.positive]: proportionChange > 0,
          [styles.negative]: proportionChange < 0,
        })}
      >
        {formatProportionChange(proportionChange)}
      </span>
    )}
  </div>
);
